import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {addHtmlBySelector, removeElementBySelector} from "@/helpers/element-helper";
import {Point} from "ol/geom";
import {setGeometryLocation} from "@/helpers/layer/info/layer-info-info-geometry-helper";
import {transformGeometryWithOptions} from "ol/format/Feature";
import {transform} from "ol/proj";
import {Feature} from "ol";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";

let keyIsRightMouseButton

export function loadRightMouseButton(coordinate, isRightMouseButton = true) {

    setKeyIsRightMouseButton(isRightMouseButton)

    blockUi('.info-menu-content', 0.5)

    const geometry = new Point(coordinate)
    const feature = new Feature(geometry)
    feature.set('kv_projection', getViewProjectionName())

    setGeometryLocation(feature, 'bookmark-right-mouse-button', undefined, undefined, '.overflow-auto')
}

export function getKeyIsRightMouseButton() {
    return keyIsRightMouseButton
}

export function setKeyIsRightMouseButton(isRightMouseButton) {
    keyIsRightMouseButton = isRightMouseButton
}
